var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.924 4.586a1.992 1.992 0 0 1 2.822 0l1.67 1.672a2 2 0 0 1-.001 2.827l-1.748 1.752a1.007 1.007 0 0 1-.24.24l-8.353 8.358c-.375.356-.88.565-1.397.565H5A1 1 0 0 1 4 18.999v-2.683c0-.535.205-1.04.582-1.419.06-.06.127-.111.196-.153l.016-.009zm-1.161 3.995-7.744 7.761-.02.017v1.639h1.678l.006-.002-.002.004 7.743-7.754-1.661-1.665zm2.572-2.576-1.159 1.161 1.662 1.665 1.16-1.16-1.663-1.666z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEdit);
export default __webpack_public_path__ + "static/media/icons-edit.6dc3854bf330168cf4be2da1dbd2176a.svg";
export { ForwardRef as ReactComponent };